import { memo } from 'react';
import MiscLocale from 'locale/en/misc.json';
import Pds08Locale from 'locale/en/pds08.json';
import { createGlobalStyle } from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';

const ModalPDS08UsageStyles = createGlobalStyle`
  #modal-pds08-usage {
  .container {
    display: flex;
    flex-direction: column;
  }

  .section {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid var(--outline-primary);
    padding: var(--spacing-24) 0;
    gap: 30px;
    flex-direction: column;
    flex-grow: 1;

    @media ${mqLargeMin} {
      flex-direction: row;
    }
  }

  .column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    li {
      display: flex;
      align-items: center;
      gap: 3px;
      margin: 15px 0;

      @media ${mqLargeMin} {
        margin: 45px 0;
      }

      img {
        width: 35px;
        max-height: 50px;
        object-fit: contain;
        margin-right: 30px;
      }
    }

    p {
      margin-top: 1em;
    }

    h5 {
      font-size: 13px;
      line-height: 24px;
      font-weight: 400;
    }
    @media ${mqLargeMin} {
      width: 50%;
    }
  }

  .usage-dot {
    display: inline-flex;
    height: 12px;

    i {
      transform: scale(0.6) translateY(7px);
      margin: 0 2px;
    }
  }
}

`;

const ModalPDS08Usage = () => (
  <>
    <ModalPDS08UsageStyles />
    <div className='head'>
      <div className='title'>{Pds08Locale.pds_08_daily_synbiotic}</div>
      <span>{Pds08Locale.how_to}</span>
    </div>
    <div className='section'>
      <div className='column'>
        <div className='top'>
          <strong>{Pds08Locale.how_to}</strong>
          <p>
            Consistent, daily use is important. Here's why: probiotics are
            generally transient—meaning they travel through the digestive tract
            interacting with immune cells, gut cells, dietary nutrients and
            existing bacteria along the way before eventually exiting the body.
            This is why consistent, daily consumption is important to activate
            specific benefits.
          </p>
          <p>
            Each component of the PDS-08® experience is designed with
            simplicity and <i>'how-do-I-get-my-kid-to-do-this-daily'</i> in
            mind.<sup>1</sup>
          </p>
        </div>
        <p className='h5-style'>
          <sup>1</sup> While probiotics are a science, parenting is not—however
          your child prefers to take PDS-08® each day, that is the best way.
        </p>
      </div>
      <div className='column'>
        <div className='top'>
          <strong>{Pds08Locale.ready}</strong>
          <ul>
            <li>
              <img
                loading='lazy'
                src='https://res.cloudinary.com/dljz0lko8/image/upload/q_auto/v1649821015/assets/PDS08_icon_star.svg'
                alt=''
              />
              <span>
                <strong>Open</strong> a sachet from your BacTrac™ container.
              </span>
            </li>
            <li>
              <img
                loading='lazy'
                src='https://res.cloudinary.com/dljz0lko8/image/upload/q_auto/v1649821015/assets/PDS08_icon_pour.svg'
                alt=''
              />
              <span>
                <strong>Pour</strong> into food or drink. Not hot, please!
              </span>
            </li>
            <li>
              <img
                loading='lazy'
                src='https://res.cloudinary.com/dljz0lko8/image/upload/q_auto/v1649821015/assets/PDS08_icon_stir.svg'
                alt=''
              />
              <span>
                <strong>Mix</strong> well. <br />
                Food—stir until fully mixed in. <br />
                Drink—thoroughly shake in a closed bottle.
              </span>
            </li>
            <li>
              <img
                loading='lazy'
                src='https://res.cloudinary.com/dljz0lko8/image/upload/q_auto/v1649821015/assets/PDS08_icon_wait.svg'
                alt=''
              />
              <span>
                <strong>Enjoy</strong> within 30 minutes. Yes, this means all of
                it!
              </span>
            </li>
            <li>
              <img
                loading='lazy'
                src='https://res.cloudinary.com/dljz0lko8/image/upload/q_auto/v1649821015/assets/PDS08_icon_bactrac.svg'
                alt=''
              />
              <span>
                <strong>Track</strong>, daily.
              </span>
            </li>
          </ul>
          <p>
            Reminder: daily, continuous use is optimal. (And we made it easy.
            Simply twist the BacTrac™ container top to align the dot
            <a
              role='link'
              tabIndex={0}
              className='usage-dot site-dot'
              aria-label={MiscLocale.brand}
            >
              <i />
            </a>
            and day so you always remember the last day of use.)
          </p>
        </div>
      </div>
    </div>
  </>
);

export default memo(ModalPDS08Usage);
